const MINUTE = 60_000;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;

/** Time left until a Trash item is removed, in the two largest units that matter. */
export function countdown(ms: number): string {
  if (ms < MINUTE) return 'less than a minute';
  const days = Math.floor(ms / DAY);
  const hours = Math.floor((ms % DAY) / HOUR);
  const minutes = Math.floor((ms % HOUR) / MINUTE);
  const unit = (n: number, word: string) => `${n} ${word}${n === 1 ? '' : 's'}`;
  if (days > 0) return hours ? `${unit(days, 'day')} ${unit(hours, 'hour')}` : unit(days, 'day');
  if (hours > 0) return minutes ? `${unit(hours, 'hour')} ${unit(minutes, 'minute')}` : unit(hours, 'hour');
  return unit(minutes, 'minute');
}

/** What the Removal column says about one item. */
export function removalText(removesAt: string | null, removing: boolean, now: number): string {
  if (removing) return 'Being removed…';
  if (!removesAt) return 'Kept — no removal date';
  const left = new Date(removesAt).getTime() - now;
  if (left <= 0) return 'At the next removal run';
  return `In ${countdown(left)}`;
}

export function formatBytes(bytes: number): string {
  if (bytes < 1024 * 1024) return `${Math.max(0, Math.round(bytes / 1024))} KB`;
  if (bytes < 1024 ** 3) return `${(bytes / 1024 ** 2).toFixed(1)} MB`;
  return `${(bytes / 1024 ** 3).toFixed(2)} GB`;
}
